import React from "react";
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";
import {useAppState} from "@stores/AppStateContext";

import {ModalBase} from "../components/ModalBase";
import {
    PriceDetailsBreakdown
} from "../../../../checkout/providers/BaseCheckout/components/PriceDetails";

import {MODALS, PriceBreakdownModalParams} from "../modal-names";
import {LoadingIcon} from "../../../components/icons/LoadingIcon";

export const PriceBreakdownModal = observer(({paymentGateway}: PriceBreakdownModalParams) => {
    const appState = useAppState();
    const activeModal = appState.topModal;

    const handleClose = () => {
        appState.setModal(null);
    };

    const isLoading = paymentGateway.isLoading || !paymentGateway.totals;

    return (
        <ModalBase
            open={activeModal === MODALS.PRICE_BREAKDOWN}
            header={intl.get('settings.billing.price_breakdown').d('Cost breakdown')}
            onClose={handleClose}
            maxWidth={560}
        >
            {
                isLoading
                    ? (
                        <div className="PriceDetails PriceDetails-loader">
                            <LoadingIcon
                                className='btn__loading'
                                type={'primary'}
                                size={null}
                            />
                        </div>
                    )
                    : (
                        <div className="PriceDetails">
                            <PriceDetailsBreakdown
                                paymentGateway={paymentGateway}
                                includeVAT={paymentGateway.canShowTax}
                                isExpanded={true}
                                standalone={true}
                            />
                        </div>
                    )
            }
        </ModalBase>
    );
});

export default PriceBreakdownModal;
